import React, { useEffect, useState } from 'react';
import api from '../../services/api';
import { LoadingSpinner } from '../../components/UI';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, PieChart, Pie, Cell, Legend } from 'recharts';

const COLORS = ['#3b82f6','#10b981','#ef4444','#f59e0b','#8b5cf6','#06b6d4'];

export default function DeptReports() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [filters, setFilters] = useState({ date_from:'', date_to:'' });

  const load = () => {
    setLoading(true);
    const params = new URLSearchParams(Object.fromEntries(Object.entries(filters).filter(([,v])=>v)));
    api.get(`/reports?${params}`).then(r => setData(r)).finally(() => setLoading(false));
  };

  useEffect(() => { load(); }, []);

  if (loading) return <LoadingSpinner size="lg" className="py-20" />;

  const statusData = data?.status_wise?.map(s => ({
    name: s.status.replace(/_/g,' '), value: parseInt(s.count)
  })) || [];

  const nocData = data?.noc_wise?.map(n => ({
    name: n.noc_name, count: parseInt(n.count)
  })) || [];

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between mb-2">
        <h1 className="text-2xl font-bold text-gray-800">📊 Reports</h1>
      </div>

      <div className="card">
        <div className="flex gap-3 items-end flex-wrap">
          <div>
            <label className="form-label">From Date</label>
            <input type="date" className="form-input" value={filters.date_from} onChange={e => setFilters(f => ({...f, date_from: e.target.value}))} />
          </div>
          <div>
            <label className="form-label">To Date</label>
            <input type="date" className="form-input" value={filters.date_to} onChange={e => setFilters(f => ({...f, date_to: e.target.value}))} />
          </div>
          <button onClick={load} className="btn-primary">Apply Filter</button>
        </div>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <div className="card">
          <h3 className="font-semibold text-gray-800 mb-4">Status Distribution</h3>
          <ResponsiveContainer width="100%" height={260}>
            <PieChart>
              <Pie data={statusData} cx="50%" cy="50%" outerRadius={90} dataKey="value" label={({name,value})=>`${name}: ${value}`} labelLine={false}>
                {statusData.map((_, i) => <Cell key={i} fill={COLORS[i % COLORS.length]} />)}
              </Pie>
              <Tooltip /><Legend />
            </PieChart>
          </ResponsiveContainer>
        </div>
        <div className="card">
          <h3 className="font-semibold text-gray-800 mb-4">NOC Type Wise</h3>
          <ResponsiveContainer width="100%" height={260}>
            <BarChart data={nocData}>
              <CartesianGrid strokeDasharray="3 3" stroke="#f0f0f0" />
              <XAxis dataKey="name" tick={{ fontSize: 11 }} />
              <YAxis tick={{ fontSize: 11 }} />
              <Tooltip />
              <Bar dataKey="count" fill="#3b82f6" radius={[4,4,0,0]} />
            </BarChart>
          </ResponsiveContainer>
        </div>
      </div>

      <div className="card">
        <h3 className="font-semibold text-gray-800 mb-4">Daily Applications (Last 30 Days)</h3>
        <ResponsiveContainer width="100%" height={220}>
          <BarChart data={data?.daily?.map(d => ({ date: d.date?.slice(5), count: parseInt(d.count) })) || []}>
            <CartesianGrid strokeDasharray="3 3" stroke="#f0f0f0" />
            <XAxis dataKey="date" tick={{ fontSize: 10 }} />
            <YAxis tick={{ fontSize: 11 }} />
            <Tooltip />
            <Bar dataKey="count" fill="#10b981" radius={[4,4,0,0]} />
          </BarChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
}
